:host {
  display: block;
  width: 100%;
  position: relative;
  font-family: $font-family-base;

  * {
    box-sizing: border-box;
    outline: none;
  }
}

.#{$prefix}context-menu-item-element {
  width: 100%;
  display: flex;
  position: relative;
  max-height: 48px;
  align-items: center;
  background: v(itemBackgroundColor);
  cursor: pointer;

  > * {
    padding: 12px;
  }

  &:hover {
    background: $context-menu-item-background-hover-color;
    text-decoration: underline;
    text-decoration-color: v(itemLabelColor);

    .#{$prefix}context-menu-item-link {
      background: $context-menu-item-background-hover-color;
      text-decoration: underline;
      text-decoration-color: v(itemLabelColor);
    }
  }

  &:focus {
    background: $context-menu-item-background-active-color;
    .#{$prefix}context-menu-item-link {
      background: $context-menu-item-background-active-color;
    }
  }

  .#{$prefix}context-menu-item-link {
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    background: v(itemBackgroundColor);

    &:hover {
      // background: $context-menu-item-background-hover-color;
      text-decoration: underline;
      text-decoration-color: v(itemLabelColor);
    }

    /* &:focus {
      background: $context-menu-item-background-active-color;
    } */
  }

  .#{$prefix}context-menu-item-label {
    text-align: left;
    width: 100%;
    flex: 1;
    justify-content: flex-start;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: v(itemLabelColor);
    cursor: pointer;
    word-break: break-word;
    overflow: hidden;
    white-space: nowrap;
  }

  .#{$prefix}context-menu-item-active-icon {
    justify-content: flex-end;
    width: 100%;
    flex: 0;
    fill: v(itemIconActiveColor);
  }

  &.#{$prefix}focused-item {
    background: $context-menu-item-background-hover-color;
    text-decoration: underline;
    text-decoration-color: v(itemLabelColor);

    .#{$prefix}context-menu-item-link {
      background: $context-menu-item-background-hover-color;
      text-decoration: underline;
      text-decoration-color: v(itemLabelColor);
    }
  }

  &.#{$prefix}selected-item {
    background: $context-menu-item-background-active-color;

    .#{$prefix}context-menu-item-link {
      background: $context-menu-item-background-active-color;
    }
  }

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      text-decoration-color: v(itemLabelColor);
    }

    &:focus {
      outline: none;
    }

    &:focus-within {
      outline: none;
    }
  }

  &.#{$prefix}small {
    max-height: 33px;

    .#{$prefix}context-menu-item-label {
      font-size: 16px;
      line-height: 22px;
    }

    > * {
      padding: 10px;
    }
  }
}
